import React, { useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import { useTheme, useMediaQuery, Paper, Box, Fade, Typography, CircularProgress, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Divider, Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, MenuItem,Checkbox,
  FormControlLabel, } from '@mui/material';
import { Edit, Delete } from '@mui/icons-material';
import api from '../api';
import { isSuperAdmin, getBusiness } from '../auth';
import { Visibility } from "@mui/icons-material";

const Template = () => {
    const superAdmin = isSuperAdmin();
    const myBusiness = getBusiness();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [categories, setCategories] = useState([]);
    const [businesses, setBusinesses] = useState([]);
    const [loading, setLoading] = useState(true);
    const [open, setOpen] = useState(false);
    const [editOpen, setEditOpen] = useState(false);
    const [deleteOpen, setDeleteOpen] = useState(false);
    const [form, setForm] = useState({
        templateCategory: "",
        name: "",
        logo: null,
        thumbnail: null,
        liveDemoUrl: "",
        description: "",
        isActive: true,

        slug: "",
        seoTitle: "",
        seoDescription: "",
        ogImage: null,
    });
    const [editForm, setEditForm] = useState({
        templateCategory: "",
        name: "",
        logo: null,
        thumbnail: null,
        liveDemoUrl: "",
        description: "",
        isActive: true,
        slug: "",
        seoTitle: "",
        seoDescription: "",
        ogImage: null,
    });
    const [selectedCategory, setSelectedCategory] = useState(null);
    const { enqueueSnackbar } = useSnackbar();
    const [templateCategories,settemplateCategories]=useState([])
    const [errors, setErrors] = useState({});
    const [viewOpen, setViewOpen] = useState(false);

    useEffect(() => {
        fetchCategories();
        fetchTemplate()
        fetchBusinesses();
    }, []);

    const fetchBusinesses = async () => {
        try {
            const { data } = await api.get('/api/businesses');
            setBusinesses(data);
        } catch (err) {
            enqueueSnackbar(err.response?.data?.message || err.message, { variant: 'error' });
        }
    };
    const fetchCategories = async () => {
        try {
            const { data } = await api.get('/api/template-categories');
            console.log('fghfghfgh',data)
            settemplateCategories(data.data);
        } catch (err) {
            enqueueSnackbar(err.response?.data?.message || err.message, { variant: 'error' });
        } finally {
            setLoading(false);
        }
    };
    const fetchTemplate = async () => {
        setLoading(true);
        try {
            const { data } = await api.get('/api/templates');
            console.log('fghfghfgh',data)
            setCategories(data.data);
        } catch (err) {
            enqueueSnackbar(err.response?.data?.message || err.message, { variant: 'error' });
        } finally {
            setLoading(false);
        }
    };

    const handleOpen = () => {setErrors({});setOpen(true);}
    const handleClose = () => setOpen(false);
    const generateSlug = (text = "") =>
    text
        .toLowerCase()
        .trim()
        .replace(/[^\w\s-]/g, "")
        .replace(/\s+/g, "-")
        .replace(/-+/g, "-");

    const handleChange = (e) => {
        const { name, value } = e.target;

        setForm((prev) => ({
            ...prev,
            [name]: value,
            ...(name === "name" && {
                slug: generateSlug(value),
            }),
        }));

        setErrors((prev) => ({
            ...prev,
            [name]: "",
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const formData = new FormData();

        formData.append("templateCategory", form.templateCategory);
        formData.append("name", form.name);
        formData.append("logo", form.logo);
        formData.append("thumbnail", form.thumbnail);
        formData.append("liveDemoUrl", form.liveDemoUrl);
        formData.append("description", form.description);
        formData.append("isActive", form.isActive);

        formData.append("slug", form.slug);
        formData.append("seoTitle", form.seoTitle);
        formData.append("seoDescription", form.seoDescription);
        formData.append("ogImage", form.ogImage);
        try {
            const response = await api.post('/api/templates', formData,{
                headers: {
                    "Content-Type": "multipart/form-data",
                    "Authorization": `Bearer ${localStorage.getItem('token')||''}`
                },
            });
            if(response.data.success){
                setForm({
                    templateCategory: "",
                    name: "",
                    logo: null,
                    thumbnail: null,
                    liveDemoUrl: "",
                    description: "",
                    isActive: true,
                    slug: "",
                    seoTitle: "",
                    seoDescription: "",
                    ogImage: null,
                });
                setOpen(false);
                fetchTemplate();
                enqueueSnackbar('Template added successfully!', { variant: 'success' });
            }
            else{
                const validationErrors = {};

                response.data.errors.forEach((item) => {
                    validationErrors[item.field] = item.message;
                });

                setErrors(validationErrors);
            }

        } catch (err) {
            console.log(err);
            console.log(err.response?.data);
            console.log(err.response?.status);
            if (err.response?.data?.errors) {
                const validationErrors = {};

                err.response.data.errors.forEach((item) => {
                    validationErrors[item.field] = item.message;
                });

                setErrors(validationErrors);
            }

            enqueueSnackbar(
                err.response?.data?.message || err.message,
                { variant: "error" }
            );
        }
    };

    const handleEditOpen = (template) => {
        setSelectedCategory(template);

        setEditForm({
            templateCategory: template.templateCategory?._id || template.templateCategory,
            name: template.name,
            liveDemoUrl: template.liveDemoUrl,
            description: template.description,
            isActive: template.isActive,
            slug: template.slug,
            seoTitle: template.seoTitle,
            seoDescription: template.seoDescription,

            logo: null,
            thumbnail: null,
            ogImage: null,
        });

        setEditOpen(true);
    };
    const handleEditClose = () => setEditOpen(false);
    const handleEditChange = (e) => {
        const { name, value } = e.target;

        setEditForm((prev) => ({
            ...prev,
            [name]: value,
            ...(name === "name" && {
                slug: generateSlug(value),
            }),
        }));
    };
    const handleEditSubmit = async (e) => {
        e.preventDefault();
        try {
            await api.put(`/api/templates/${selectedCategory._id}`, editForm);
            setEditOpen(false);
            fetchTemplate();
            enqueueSnackbar('Category updated successfully!', { variant: 'success' });
        } catch (err) {
            enqueueSnackbar(err.response?.data?.message || err.message, { variant: 'error' });
        }
    };

    const handleDeleteOpen = (cat) => {
        setSelectedCategory(cat);
        setDeleteOpen(true);
    };
    const handleDeleteClose = () => setDeleteOpen(false);
    const handleDeleteConfirm = async () => {
        try {
            await api.delete(`/api/templates/${selectedCategory._id}`);
            setDeleteOpen(false);
            fetchTemplate();
            enqueueSnackbar('Category deleted successfully!', { variant: 'success' });
        } catch (err) {
            enqueueSnackbar(err.response?.data?.message || err.message, { variant: 'error' });
        }
    };

    const handleViewOpen = (template) => {
        setSelectedCategory(template);
        setViewOpen(true);
    };

    const handleViewClose = () => {
        setViewOpen(false);
    };

    return (
        <Box sx={{ mt: isMobile ? 2 : 4 }}>
            <Fade in timeout={600}>
                <Paper elevation={isMobile ? 0 : 4} sx={{ borderRadius: 2, bgcolor: 'background.paper', boxShadow: isMobile ? 0 : 1 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', p: isMobile ? 1 : 2, justifyContent: 'space-between' }}>
                        <Typography variant={isMobile ? 'h6' : 'h5'} sx={{ flexGrow: 1 }} gutterBottom>
                            Templates
                        </Typography>
                        <Button variant="contained" color="primary" onClick={handleOpen} sx={{ width: isMobile ? '100%' : 'auto', boxShadow: 2, fontWeight: 600 }}>
                            Add Template
                        </Button>
                    </Box>
                    <Divider />
                    {loading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 180 }}>
                            <CircularProgress />
                        </Box>
                    ) : categories&&categories.length === 0 ? (
                        <Box sx={{ textAlign: 'center', color: 'text.secondary', py: 6 }}>
                            <Typography variant="body1">No categories found.</Typography>
                        </Box>
                    ) : (
                         <TableContainer component={Paper} sx={{ boxShadow:  0 , borderRadius: 1, transition: 'box-shadow 0.3s' }}>
                                     <Table size={'small'}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>S.No.</TableCell>
                                        <TableCell>Template Category</TableCell>
                                        <TableCell>Name</TableCell>
                                        <TableCell>Status</TableCell>
                                        <TableCell>Logo</TableCell>
                                        <TableCell align="right">Actions</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {categories&&categories?.map((cat,index) => (
                                        <TableRow key={cat._id} hover sx={{ transition: 'background 0.2s', '&:hover': { bgcolor: 'action.hover' } }}>
                                            <TableCell>{index + 1}</TableCell>
                                            <TableCell>{cat.templateCategory.name}</TableCell>
                                            <TableCell>{cat.name}</TableCell>
                                            <TableCell>{cat.isActive ? "Active" : "Inactive"}</TableCell>
                                            <TableCell><img src={cat.logo} style={{width:'60px'}}/></TableCell>
                                            <TableCell align="right">
                                                <Button
                                                    size="small"
                                                    color="info"
                                                    startIcon={<Visibility />}
                                                    onClick={() => handleViewOpen(cat)}
                                                    sx={{ mr: 1 }}
                                                >
                                                    View
                                                </Button>
                                                <Button size="small" color="primary" onClick={() => handleEditOpen(cat)} startIcon={<Edit />} sx={{ mr: 1 }}>
                                                    Edit
                                                </Button>
                                                <Button size="small" color="error" onClick={() => handleDeleteOpen(cat)} startIcon={<Delete />}>Delete</Button>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    )}
                    {/* Add Dialog */}
                    <Dialog open={open} onClose={handleClose} fullScreen={isMobile} TransitionComponent={Fade} transitionDuration={400}>
                        <DialogTitle sx={{ fontWeight: 700 }}>Add Template</DialogTitle>
                        <DialogContent>
                            <form onSubmit={handleSubmit} id="category-form">
                                <TextField
                                    select
                                    fullWidth
                                    margin="dense"
                                    label="Template Category"
                                    name="templateCategory"
                                    value={form.templateCategory}
                                    onChange={handleChange}
                                    error={!!errors.templateCategory}
                                    helperText={errors.templateCategory}
                                    required
                                    sx={{ mb: 2 }}
                                >
                                    {templateCategories.map((category) => (
                                        <MenuItem key={category._id} value={category._id}>
                                            {category.name}
                                        </MenuItem>
                                    ))}
                                </TextField>

                                <TextField
                                    margin="dense"
                                    label="Name"
                                    name="name"
                                    value={form.name}
                                    onChange={handleChange}
                                    fullWidth
                                    required
                                    sx={{ mb: 2 }}
                                    error={!!errors.name}
                                    helperText={errors.name}
                                />

                                <Button
                                    variant="outlined"
                                    component="label"
                                    fullWidth
                                    sx={{ mb: 2 }}
                                    color={errors.logo ? "error" : "primary"}
                                >
                                    Upload Logo
                                    <input
                                        hidden
                                        type="file"
                                        accept="image/*"
                                        onChange={(e) => {
                                            setForm({
                                            ...form,
                                            logo: e.target.files[0],
                                        });

                                        setErrors((prev) => ({
                                            ...prev,
                                            logo: "",
                                        }));
                                    }}
                                    />
                                </Button>
                                {errors.logo && (
                                    <Typography
                                        variant="caption"
                                        color="error"
                                        sx={{ display: "block", mt: 0.5 }}
                                    >
                                        {errors.logo}
                                    </Typography>
                                )}

                                <Button
                                    variant="outlined"
                                    component="label"
                                    fullWidth
                                    sx={{ mb: 2 }}
                                    color={errors.thumbnail ? "error" : "primary"}
                                >
                                    Upload Thumbnail
                                    <input
                                        hidden
                                        type="file"
                                        accept="image/*"
                                        onChange={(e) => {
                                            setForm({
                                                ...form,
                                                thumbnail: e.target.files[0],
                                            });

                                            setErrors((prev) => ({
                                                ...prev,
                                                thumbnail: "",
                                            }));
                                        }}
                                    />
                                </Button>
                                {errors.thumbnail && (
                                    <Typography
                                        variant="caption"
                                        color="error"
                                        sx={{ display: "block", mt: 0.5 }}
                                    >
                                        {errors.thumbnail}
                                    </Typography>
                                )}

                                <TextField
                                    margin="dense"
                                    label="Live Demo URL"
                                    name="liveDemoUrl"
                                    value={form.liveDemoUrl}
                                    onChange={handleChange}
                                    fullWidth
                                    sx={{ mb: 2 }}
                                    error={!!errors.liveDemoUrl}
                                    helperText={errors.liveDemoUrl}
                                />

                                <TextField
                                    margin="dense"
                                    label="Description"
                                    name="description"
                                    value={form.description}
                                    onChange={handleChange}
                                    fullWidth
                                    multiline
                                    rows={4}
                                    sx={{ mb: 2 }}
                                    error={!!errors.description}
                                    helperText={errors.description}
                                />

                                <Divider sx={{ my: 3 }} />

                                <Typography
                                    variant="h6"
                                    sx={{
                                        fontWeight: 600,
                                        mb: 2,
                                    }}
                                >
                                    SEO Details
                                </Typography>

                                <TextField
                                    margin="dense"
                                    label="Slug"
                                    name="slug"
                                    value={form.slug}
                                    onChange={handleChange}
                                    fullWidth
                                    sx={{ mb: 2 }}
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                />

                                <TextField
                                    margin="dense"
                                    label="SEO Title"
                                    name="seoTitle"
                                    value={form.seoTitle}
                                    onChange={handleChange}
                                    fullWidth
                                    sx={{ mb: 2 }}
                                    error={!!errors.seoTitle}
                                    helperText={errors.seoTitle}
                                />

                                <TextField
                                    margin="dense"
                                    label="SEO Description"
                                    name="seoDescription"
                                    value={form.seoDescription}
                                    onChange={handleChange}
                                    fullWidth
                                    multiline
                                    rows={3}
                                    sx={{ mb: 2 }}
                                    error={!!errors.seoDescription}
                                    helperText={errors.seoDescription}
                                />

                                <Button
                                    variant="outlined"
                                    component="label"
                                    fullWidth
                                    sx={{ mb: 2 }}
                                    color={errors.ogImage ? "error" : "primary"}
                                >
                                    Upload OG Image
                                    <input
                                        hidden
                                        type="file"
                                        accept="image/*"
                                        onChange={(e) => {
                                            setForm({
                                                ...form,
                                                ogImage: e.target.files[0],
                                            });

                                            setErrors((prev) => ({
                                                ...prev,
                                                ogImage: "",
                                            }));
                                        }}
                                    />
                                </Button>

                                {errors.ogImage && (
                                    <Typography
                                        variant="caption"
                                        color="error"
                                        sx={{ display: "block", mt: 0.5 }}
                                    >
                                        {errors.ogImage}
                                    </Typography>
                                )}

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={form.isActive}
                                            onChange={(e) =>
                                                setForm({
                                                    ...form,
                                                    isActive: e.target.checked,
                                                })
                                            }
                                        />
                                    }
                                    label="Active"
                                />
                            </form>
                        </DialogContent>
                        <DialogActions sx={{ px: 3, pb: 2 }}>
                            <Button onClick={handleClose} sx={{ width: isMobile ? '100%' : 'auto', fontWeight: 600 }}>Cancel</Button>
                            <Button type="submit" form="category-form" variant="contained" sx={{ width: isMobile ? '100%' : 'auto', fontWeight: 600 }}>Save</Button>
                        </DialogActions>
                    </Dialog>
                    {/* Edit Dialog */}
                    <Dialog open={editOpen} onClose={handleEditClose} fullScreen={isMobile} TransitionComponent={Fade} transitionDuration={400}>
                        <DialogTitle sx={{ fontWeight: 700 }}>Edit Template</DialogTitle>
                        <DialogContent>
                            <form onSubmit={handleEditSubmit} id="edit-category-form">
                                <TextField
                                    select
                                    fullWidth
                                    margin="dense"
                                    label="Template Category"
                                    name="templateCategory"
                                    value={editForm.templateCategory}
                                    onChange={handleEditChange}
                                    error={!!errors.templateCategory}
                                    helperText={errors.templateCategory}
                                    required
                                    sx={{ mb: 2 }}
                                >
                                    {templateCategories.map((category) => (
                                        <MenuItem key={category._id} value={category._id}>
                                            {category.name}
                                        </MenuItem>
                                    ))}
                                </TextField>

                                <TextField
                                    margin="dense"
                                    label="Name"
                                    name="name"
                                    value={editForm.name}
                                    onChange={handleEditChange}
                                    fullWidth
                                    required
                                    sx={{ mb: 2 }}
                                    error={!!errors.name}
                                    helperText={errors.name}
                                />

                                <Button
                                    variant="outlined"
                                    component="label"
                                    fullWidth
                                    sx={{ mb: 2 }}
                                    color={errors.logo ? "error" : "primary"}
                                >
                                    Upload Logo
                                    <input
                                        hidden
                                        type="file"
                                        accept="image/*"
                                        onChange={(e) => {
                                            setEditForm({
                                            ...editForm,
                                            logo: e.target.files[0],
                                        });

                                        setErrors((prev) => ({
                                            ...prev,
                                            logo: "",
                                        }));
                                    }}
                                    />
                                </Button>
                                {errors.logo && (
                                    <Typography
                                        variant="caption"
                                        color="error"
                                        sx={{ display: "block", mt: 0.5 }}
                                    >
                                        {errors.logo}
                                    </Typography>
                                )}

                                <Button
                                    variant="outlined"
                                    component="label"
                                    fullWidth
                                    sx={{ mb: 2 }}
                                    color={errors.thumbnail ? "error" : "primary"}
                                >
                                    Upload Thumbnail
                                    <input
                                        hidden
                                        type="file"
                                        accept="image/*"
                                        onChange={(e) => {
                                            setEditForm({
                                                ...editForm,
                                                thumbnail: e.target.files[0],
                                            });

                                            setErrors((prev) => ({
                                                ...prev,
                                                thumbnail: "",
                                            }));
                                        }}
                                    />
                                </Button>
                                {errors.thumbnail && (
                                    <Typography
                                        variant="caption"
                                        color="error"
                                        sx={{ display: "block", mt: 0.5 }}
                                    >
                                        {errors.thumbnail}
                                    </Typography>
                                )}

                                <TextField
                                    margin="dense"
                                    label="Live Demo URL"
                                    name="liveDemoUrl"
                                    value={editForm.liveDemoUrl}
                                    onChange={handleEditChange}
                                    fullWidth
                                    sx={{ mb: 2 }}
                                    error={!!errors.liveDemoUrl}
                                    helperText={errors.liveDemoUrl}
                                />

                                <TextField
                                    margin="dense"
                                    label="Description"
                                    name="description"
                                    value={editForm.description}
                                    onChange={handleEditChange}
                                    fullWidth
                                    multiline
                                    rows={4}
                                    sx={{ mb: 2 }}
                                    error={!!errors.description}
                                    helperText={errors.description}
                                />

                                <Divider sx={{ my: 3 }} />

                                <Typography
                                    variant="h6"
                                    sx={{
                                        fontWeight: 600,
                                        mb: 2,
                                    }}
                                >
                                    SEO Details
                                </Typography>

                                <TextField
                                    margin="dense"
                                    label="Slug"
                                    name="slug"
                                    value={editForm.slug}
                                    onChange={handleEditChange}
                                    fullWidth
                                    sx={{ mb: 2 }}
                                     InputProps={{
                                        readOnly: true,
                                    }}
                                />

                                <TextField
                                    margin="dense"
                                    label="SEO Title"
                                    name="seoTitle"
                                    value={editForm.seoTitle}
                                    onChange={handleEditChange}
                                    fullWidth
                                    sx={{ mb: 2 }}
                                    error={!!errors.seoTitle}
                                    helperText={errors.seoTitle}
                                />

                                <TextField
                                    margin="dense"
                                    label="SEO Description"
                                    name="seoDescription"
                                    value={editForm.seoDescription}
                                    onChange={handleEditChange}
                                    fullWidth
                                    multiline
                                    rows={3}
                                    sx={{ mb: 2 }}
                                    error={!!errors.seoDescription}
                                    helperText={errors.seoDescription}
                                />

                                <Button
                                    variant="outlined"
                                    component="label"
                                    fullWidth
                                    sx={{ mb: 2 }}
                                    color={errors.ogImage ? "error" : "primary"}
                                >
                                    Upload OG Image
                                    <input
                                        hidden
                                        type="file"
                                        accept="image/*"
                                        onChange={(e) => {
                                            setEditForm({
                                                ...editForm,
                                                ogImage: e.target.files[0],
                                            });

                                            setErrors((prev) => ({
                                                ...prev,
                                                ogImage: "",
                                            }));
                                        }}
                                    />
                                </Button>

                                {errors.ogImage && (
                                    <Typography
                                        variant="caption"
                                        color="error"
                                        sx={{ display: "block", mt: 0.5 }}
                                    >
                                        {errors.ogImage}
                                    </Typography>
                                )}

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={editForm.isActive}
                                            onChange={(e) =>
                                                setEditForm({
                                                    ...editForm,
                                                    isActive: e.target.checked,
                                                })
                                            }
                                        />
                                    }
                                    label="Active"
                                />
                            </form>
                        </DialogContent>
                        <DialogActions sx={{ px: 3, pb: 2 }}>
                            <Button onClick={handleEditClose} sx={{ width: isMobile ? '100%' : 'auto', fontWeight: 600 }}>Cancel</Button>
                            <Button type="submit" form="edit-category-form" variant="contained" sx={{ width: isMobile ? '100%' : 'auto', fontWeight: 600 }}>Update</Button>
                        </DialogActions>
                    </Dialog>
                    {/* Delete Confirmation Dialog */}
                    <Dialog open={deleteOpen} onClose={handleDeleteClose} fullScreen={isMobile} TransitionComponent={Fade} transitionDuration={400}>
                        <DialogTitle sx={{ fontWeight: 700 }}>Delete Template</DialogTitle>
                        <DialogContent>
                            <Typography>Are you sure you want to delete <b>{selectedCategory?.name}</b>?</Typography>
                        </DialogContent>
                        <DialogActions sx={{ px: 3, pb: 2 }}>
                            <Button onClick={handleDeleteClose} sx={{ width: isMobile ? '100%' : 'auto', fontWeight: 600 }}>Cancel</Button>
                            <Button onClick={handleDeleteConfirm} color="error" variant="contained" sx={{ width: isMobile ? '100%' : 'auto', fontWeight: 600 }}>Delete</Button>
                        </DialogActions>
                    </Dialog>
                    <Dialog
                        open={viewOpen}
                        onClose={handleViewClose}
                        maxWidth="md"
                        fullWidth
                    >
                        <DialogTitle>Template Details</DialogTitle>

                        <DialogContent dividers>

                            <Typography><b>Name:</b> {selectedCategory?.name}</Typography>

                            <Typography sx={{ mt: 2 }}>
                                <b>Category:</b>{" "}
                                {selectedCategory?.templateCategory?.name}
                            </Typography>

                            <Typography sx={{ mt: 2 }}>
                                <b>Slug:</b> {selectedCategory?.slug}
                            </Typography>

                            <Typography sx={{ mt: 2 }}>
                                <b>Live Demo:</b>
                            </Typography>

                            <Typography color="primary">
                                {selectedCategory?.liveDemoUrl}
                            </Typography>

                            <Typography sx={{ mt: 2 }}>
                                <b>Description:</b>
                            </Typography>

                            <Typography>
                                {selectedCategory?.description}
                            </Typography>

                            <Divider sx={{ my: 3 }} />

                            <Typography variant="h6">
                                SEO Details
                            </Typography>

                            <Typography>
                                <b>SEO Title:</b> {selectedCategory?.seoTitle}
                            </Typography>

                            <Typography sx={{ mt: 2 }}>
                                <b>SEO Description:</b>
                            </Typography>

                            <Typography>
                                {selectedCategory?.seoDescription}
                            </Typography>

                            <Divider sx={{ my: 3 }} />

                            <Box
                                display="flex"
                                gap={3}
                                flexWrap="wrap"
                            >
                                <Box>
                                    <Typography fontWeight={600}>
                                        Logo
                                    </Typography>

                                    <img
                                        src={selectedCategory?.logo}
                                        width={120}
                                        alt=""
                                    />
                                </Box>

                                <Box>
                                    <Typography fontWeight={600}>
                                        Thumbnail
                                    </Typography>

                                    <img
                                        src={selectedCategory?.thumbnail}
                                        width={120}
                                        alt=""
                                    />
                                </Box>

                                <Box>
                                    <Typography fontWeight={600}>
                                        OG Image
                                    </Typography>

                                    <img
                                        src={selectedCategory?.ogImage}
                                        width={120}
                                        alt=""
                                    />
                                </Box>
                            </Box>

                        </DialogContent>

                        <DialogActions>
                            <Button onClick={handleViewClose}>
                                Close
                            </Button>
                        </DialogActions>
                    </Dialog>
                </Paper>
            </Fade>
        </Box>
    );
};

export default Template;
